/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inserting_Blank_Frames_FailedInputs */

const en_inserting_blank_frames_failed = /** @type {(inputs: Inserting_Blank_Frames_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserting blank frames failed`)
};

const fr_inserting_blank_frames_failed = /** @type {(inputs: Inserting_Blank_Frames_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de l’insertion d’images vides`)
};

const de_inserting_blank_frames_failed = /** @type {(inputs: Inserting_Blank_Frames_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Einfügen leerer Frames ist fehlgeschlagen.`)
};

const it_inserting_blank_frames_failed = /** @type {(inputs: Inserting_Blank_Frames_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserimento di frame vuoti non riuscito`)
};

const ru_inserting_blank_frames_failed = /** @type {(inputs: Inserting_Blank_Frames_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось вставить пустые рамки.`)
};

const es_inserting_blank_frames_failed = /** @type {(inputs: Inserting_Blank_Frames_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al insertar marcos en blanco`)
};

const zh_cn2_inserting_blank_frames_failed = /** @type {(inputs: Inserting_Blank_Frames_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插入空白帧失败`)
};

const ja_inserting_blank_frames_failed = /** @type {(inputs: Inserting_Blank_Frames_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空白フレームの挿入に失敗しました`)
};

const hi_inserting_blank_frames_failed = /** @type {(inputs: Inserting_Blank_Frames_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खाली फ्रेम डालने में विफलता`)
};

const pt_pt2_inserting_blank_frames_failed = /** @type {(inputs: Inserting_Blank_Frames_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A inserção de quadros em branco falhou.`)
};

/**
* | output |
* | --- |
* | "Inserting blank frames failed" |
*
* @param {Inserting_Blank_Frames_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const inserting_blank_frames_failed = /** @type {((inputs?: Inserting_Blank_Frames_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inserting_Blank_Frames_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_inserting_blank_frames_failed(inputs)
	if (locale === "de") return de_inserting_blank_frames_failed(inputs)
	if (locale === "it") return it_inserting_blank_frames_failed(inputs)
	if (locale === "ru") return ru_inserting_blank_frames_failed(inputs)
	if (locale === "es") return es_inserting_blank_frames_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_inserting_blank_frames_failed(inputs)
	if (locale === "ja") return ja_inserting_blank_frames_failed(inputs)
	if (locale === "hi") return hi_inserting_blank_frames_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_inserting_blank_frames_failed(inputs)
	return en_inserting_blank_frames_failed(inputs)
});